import Vue from "vue";
// Vue 2.7+ has built-in Composition API, no need for @vue/composition-api plugin
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./plugins/request";
import vuetify from "./plugins/vuetify";
import { createProvider } from "./plugins/vue-apollo";

// Import Roboto font locally (maintains design consistency)
import '@fontsource/roboto/300.css';  // Light
import '@fontsource/roboto/400.css';  // Regular
import '@fontsource/roboto/500.css';  // Medium
import '@fontsource/roboto/700.css';  // Bold

// Import Material Design Icons CSS locally (for main app UI)
import '@mdi/font/css/materialdesignicons.css';

//Global Components
import CurrencyTextField from "./components/CurrencyTextField.vue";
import PricingCalculator from "./helpers/PricingCalculator";

// Helpers
import { systemCategoriesPlugin } from "./helpers/systemCategories";
import InventoryCatalog from "./plugins/inventoryCatalog";
import UserService from "./plugins/userService";
import { navigationPlugin } from "./plugins/navigationPlugin";

Vue.component("currency-text-field", CurrencyTextField);

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

Vue.prototype.$formatDate = function (date: string | null) {
	if (!date) return "";

	date = date.substring(0, 10);

	if (date.includes("-")) {
		const [year, month, day] = date.split("-");
		return `${month}/${day}/${year}`;
	} else if (date.includes("/")) {
		const [month, day, year] = date.split("/");
		return `${month}/${day}/${year}`;
	} else {
		return date;
	}
};

Vue.use(systemCategoriesPlugin);
Vue.prototype.$catalog = new InventoryCatalog(createProvider().defaultClient);
Vue.prototype.$userService = new UserService(createProvider().defaultClient);

// Second vue instance to handle events.
Vue.prototype.$bus = new Vue();

Vue.use({
	install: function (_v) {
		// Make sure we have a single instance across the app.
		if (_v.prototype.$pricing !== undefined) {
			return;
		}

		// Add the instance to the prototype.
		_v.prototype.$pricing = new PricingCalculator();
		//_v.prototype.$systemCategories = SystemCategories;
	},
});

Vue.use(navigationPlugin, {
	onBack: ({ delta, from, to }) => {
		Vue.prototype.$bus.$emit("navigation:back", { delta, from, to });
	},
	onForward: ({ delta, from, to }) => {
		Vue.prototype.$bus.$emit("navigation:forward", { delta, from, to });
	},
});

// Auto-select number input values on focus for faster data entry.
// When tabbing into a quantity field (or any .number-input), the existing value
// is fully selected so typing immediately replaces it instead of appending.
document.addEventListener('focusin', (e) => {
	const target = e.target as HTMLInputElement;
	if (target.tagName === 'INPUT' && target.type === 'number' && target.closest('.number-input')) {
		target.select();
	}
});

new Vue({
	router,
	vuetify,
	store,
	apolloProvider: createProvider(),
	render: (h) => h(App),
	created() {
		Vue.prototype.$setupNavigationTracking(router);
	},
}).$mount("#app");
